import React from 'react';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 9;
const FILLED_PERCENT = 93;

/** Scarcity trigger: an almost-full progress bar with remaining promo spots. */
export function ScarcityBar() {
  return <div className="mx-auto mt-6 w-full max-w-md rounded-2xl border border-red-200 bg-red-50 p-4" data-id="element-49" data-mp="2l3uzmfledu2o">
      <div className="flex items-center justify-between gap-2" data-id="element-50" data-mp="2q2zdhjj9ofzc">
        <p className="flex items-center gap-1.5 text-[12px] font-bold uppercase tracking-wide text-red-700" data-id="element-51" data-mp="2b703g3clk5rk">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="2g6ctewyrlsyd" />
          Promo price spots
        </p>
        <span className="text-[12px] font-extrabold text-red-700" data-id="element-53" data-mp="226ll9cuxj6sa">{SPOTS_LEFT} left</span>
      </div>
      <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots already taken" data-id="element-54" data-mp="274d8vuojk6qo">
        <div className="h-full rounded-full bg-red-600" style={{
        width: `${FILLED_PERCENT}%`
      }} data-id="element-55" data-mp="33mv8wpe8nl8d" />
      </div>
      <p className="mt-2 text-[11px] leading-snug text-red-700/90" data-id="element-56" data-mp="2zlje85gic9tb">
        {FILLED_PERCENT}% of the spots are already taken. Once it hits 100%, the price goes back
        to $394 USD.
      </p>
    </div>;
}